<div class="daisy-card daisy-card-bordered p-2 w-full">
  <div class="daisy-card-body flex flex-col items-center w-full">
    <!-- Error Alert -->
    @if (uploadError) {
      <div class="daisy-alert daisy-alert-error mb-2 w-full">
        <span>{{ uploadError }}</span>
      </div>
    }

    <!-- Uploaded Image Preview with Remove Button -->
    @if (uploadedImageUrl) {
      <div class="w-full flex flex-col items-center relative">
        <img [src]="uploadedImageUrl" alt="Uploaded Image Preview" class="rounded-sm max-w-full w-full max-h-full sm:max-h-56 object-contain aspect-video" />
        <button
          class="daisy-btn daisy-btn-circle daisy-btn-error absolute top-2 right-2 z-10"
          (click)="removeImage()"
          aria-label="Remove image"
          type="button"
          >
          <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
      </div>
    }

    <!-- Upload Button and File Input (hidden after upload) -->
    @if (!uploadedImageUrl) {
      <div class="w-full flex flex-col items-center">
        <label class="daisy-btn daisy-btn-outline daisy-btn-primary w-full mb-4 cursor-pointer flex justify-center items-center">
          <input
            type="file"
            accept="image/*"
            class="hidden"
            (change)="handleFileInput($event)"
            [disabled]="isUploading"
            />
            @if (!isUploading) {
              <span>Click to Upload Image</span>
            }
            @if (isUploading) {
              <span class="loading loading-spinner"></span>
            }
          </label>
        </div>
      }
    </div>
  </div>

  <!-- Cropper Modal -->
  <dialog class="daisy-modal" [open]="isCropping">
    <form method="dialog" class="daisy-modal-box w-full max-w-2xl" (submit)="$event.preventDefault()">
      <h3 class="font-bold text-lg mb-4">Crop Image</h3>
      <image-cropper
        [imageChangedEvent]="imageChangedEvent"
        [maintainAspectRatio]="true"
        [aspectRatio]="16/9"
        [resizeToWidth]="1280"
        format="png"
        [cropperMinWidth]="160"
        [cropperMinHeight]="90"
        [imageQuality]="100"
        [roundCropper]="false"
        (imageCropped)="imageCropped($event)"
        (imageLoaded)="imageLoaded()"
        (cropperReady)="cropperReady()"
        (loadImageFailed)="loadImageFailed()"
      ></image-cropper>
      <div class="flex gap-2 mt-4 justify-end">
        <button
          class="daisy-btn daisy-btn-success"
          [disabled]="isUploading || !croppedImage && !croppedBlob"
          (click)="uploadCroppedImage()"
          type="button"
          >
          @if (!isUploading) {
            <span>Upload</span>
          }
          @if (isUploading) {
            <span class="daisy-loading daisy-loading-spinner"></span>
          }
        </button>
        <button class="daisy-btn daisy-btn-outline" (click)="reset()" [disabled]="isUploading" type="button">Cancel</button>
      </div>
    </form>
  </dialog>